import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Footer';
import './styles/EventsPage.css';

const PROGRAM_CARDS = [
  {
    icon: '🎭',
    title: 'Kulturális Programok',
    text: 'Zenei délutánok, koncertek, filmvetítések és irodalmi estek várják az érdeklődőket.',
  },
  {
    icon: '🏃‍♀️',
    title: 'Egészségmegőrző Foglalkozások',
    text: 'Reggeli tornák, gyógytorna, fizioterápia és természetjárás az egészségért.',
  },
  {
    icon: '🎨',
    title: 'Kreatív Tevékenységek',
    text: 'Kézműves foglalkozások, festés, kertészkedés és főzőórák a kreativitás jegyében.',
  },
  {
    icon: '🎲',
    title: 'Társasági Programok',
    text: 'Kártyapartik, társasjátékok, bingo estek és beszélgetős körök a közösségért.',
  },
];

const MENU_CARDS = [
  {
    icon: '🍽️',
    title: 'Változatos Menük',
    text: 'Normál, diabetikus, pépes, kímélő, vitál, tejmentes és laktózmentes étrendek.',
  },
  {
    icon: '⏰',
    title: 'Napi Ötszöri Étkezés',
    text: 'Reggeli, tízórai, ebéd, uzsonna és vacsora biztosított minden nap.',
  },
  {
    icon: '🩺',
    title: 'Orvosi Felügyelet',
    text: 'Diétás ételek orvosi elrendelésre, egyéni igények figyelembevételével.',
  },
];

const EventsPage = () => {
  return (
    <div className="events-page">
      <section className="events-section">
        <div className="container">
          <header className="events-page-hero">
            <h1 className="events-page-hero__title">Események</h1>
          </header>

          <div className="events-block events-block--programs">
            <div className="events-block-header">
              <span className="events-block-header__mark" aria-hidden="true">
                ✱
              </span>
              <h2 className="events-block-header__title">Napi Programjaink</h2>
            </div>
            <p className="events-block-intro">
              Minden nap változatos és tartalmas programokat kínálunk lakóinknak. Kulturális
              eseményektől a sport- és egészségmegőrző foglalkozásokig mindenki megtalálja a
              számára megfelelő tevékenységet.
            </p>

            <div className="events-feature-grid events-feature-grid--programs">
              {PROGRAM_CARDS.map((card) => (
                <article key={card.title} className="events-feature-card">
                  <div className="events-feature-card__icon" aria-hidden="true">
                    {card.icon}
                  </div>
                  <h3 className="events-feature-card__title">{card.title}</h3>
                  <p className="events-feature-card__text">{card.text}</p>
                </article>
              ))}
            </div>

            <div className="events-cta events-cta--programs">
              <div className="events-cta__icon" aria-hidden="true">
                📅
              </div>
              <p className="events-cta__text">
                Tekintse meg a pontos időpontokat és részleteket a havi naptárban!
              </p>
              <Link to="/naptar" className="events-cta__btn">
                Naptár Megtekintése
              </Link>
            </div>
          </div>

          <div className="events-block events-block--menu">
            <div className="events-block-header">
              <span className="events-block-header__mark" aria-hidden="true">
                ✱
              </span>
              <h2 className="events-block-header__title">Heti Étlap</h2>
            </div>
            <p className="events-block-intro">
              Egészséges és ízletes ételekkel gondoskodunk lakóink jó közérzetéről. Menüinket
              dietetikus szakember állítja össze, figyelembe véve a különleges táplálkozási
              igényeket is.
            </p>

            <div className="events-feature-grid events-feature-grid--menu">
              {MENU_CARDS.map((card) => (
                <article key={card.title} className="events-feature-card">
                  <div className="events-feature-card__icon" aria-hidden="true">
                    {card.icon}
                  </div>
                  <h3 className="events-feature-card__title">{card.title}</h3>
                  <p className="events-feature-card__text">{card.text}</p>
                </article>
              ))}
            </div>

            <div className="events-cta events-cta--menu">
              <div className="events-cta__icon" aria-hidden="true">
                🍽️
              </div>
              <p className="events-cta__text">
                Az aktuális heti étlap megtekintéséhez látogasson el az étlap oldalra!
              </p>
              <Link to="/heti-etlap" className="events-cta__btn">
                Heti Étlap Megtekintése
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default EventsPage;
